import { render } from "./Report_delay.vue?vue&type=template&id=3ff71bd8"
import script from "./Report_delay.vue?vue&type=script&lang=js"
export * from "./Report_delay.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__